<app-toast></app-toast>
<app-delete-account-dialog #deleteAccountDialog></app-delete-account-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.settings' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.company_information' | transloco }}"
                    link="/settings/company"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.my_profile' | transloco }}" [isActive]="true"
                    link="/settings/profile"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.team' | transloco }}" link="/settings/team"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.billing' | transloco }}"
                    link="/settings/billing"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.plans' | transloco }}"
                    link="/settings/plans"></app-tab-button>
            </div>

            <!-- User Banner -->
            <app-user-banner [editing]="isUserEditing" (editButtonClick)="editSaveButtonClick()"></app-user-banner>

            <!-- Personal Information -->
            <div
                class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] h-auto border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">
                <!-- Header text -->
                <div class="flex">
                    <div class="flex flex-col gap-4 h-[60px] justify-between">
                        <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                            'shared.labels.personal_information' | transloco }}
                        </p>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
                <!-- Content -->
                <div class="m-4 flex flex-col">
                    <div class="w-full flex flex-wrap gap-5">
                        <div class="max-w-screen-sm flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.personal.first_name' | transloco }}"
                                [inputId]="'fname'" [inputType]="'text'" [(inputValue)]="firstNameInput"
                                [errorMessage]="firstNameInputError"
                                placeholder="{{ 'shared.placeholders.personal.first_name' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <div class="max-w-screen-sm flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.personal.last_name' | transloco }}"
                                [inputId]="'lname'" [inputType]="'text'" [(inputValue)]="lastNameInput"
                                [errorMessage]="lastNameInputError"
                                placeholder="{{ 'shared.placeholders.personal.last_name' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>
                    </div>
                    <div class="w-full flex flex-wrap gap-5">
                        <div class="max-w-screen-sm flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.personal.set_new_password' | transloco }}"
                                [inputId]="'password'" [inputType]="'password'" [(inputValue)]="passwordInput"
                                [errorMessage]="passwordInputError"
                                placeholder="{{ 'shared.placeholders.personal.set_new_password' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <div class="max-w-screen-sm flex-[1] min-w-[300px] mobile:w-full">
                            <app-custom-dropdown [options]="rolesOptions" [(selectedOption)]="selectedRole"
                                label="{{ 'shared.select_role' | transloco }}"
                                placeholder="{{ 'shared.select_role' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle">
                            </app-custom-dropdown>
                        </div>

                        <div class="max-w-screen-sm flex-[1] min-w-[300px] mobile:w-full">
                            <app-custom-dropdown [options]="languageOptions" [(selectedOption)]="selectedLanguage"
                                label="{{ 'shared.labels.language' | transloco }}"
                                placeholder="{{ 'shared.placeholders.language' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle">
                            </app-custom-dropdown>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Personal Information -->
            <div
                class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] h-auto border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">
                <!-- Header text -->
                <div class="flex">
                    <div class="flex flex-col gap-4 h-[60px] justify-between">
                        <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                            'settings.account_settings' | transloco }}
                        </p>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
                <!-- Content -->
                <div class="m-4 flex flex-col">
                    <p class="mt-1 text-sm text-gray-700">
                        {{ 'settings.account.delete_desc' | transloco }}
                    </p>

                    <button type="button"
                        class="w-fit text-sm font-bold text-error hover:underline underline-offset-2 hover:opacity-80"
                        (click)="deleteAccount()">
                        {{ 'settings.account.delete_cta' | transloco }}
                    </button>
                </div>

            </div>

            <!-- Security settings -->
            <!--
        <div
            class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] h-auto border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">-->
            <!-- Header text -->
            <!--
            <div class="flex">
                <div class="flex flex-col gap-4 h-[60px] justify-between">
                    <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'settings.security_settings'
                        | transloco }}
                    </p>
                    <div class="h-[2px] w-full bg-primary"></div>
                </div>
                <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                    <div class="h-[2px] w-full bg-border"></div>
                </div>
            </div>-->
            <!-- Content -->
            <!--
            <div class="m-4 flex flex-col gap-2">
                <div
                    class="flex flex-wrap justify-between gap-2 mobile:flex-col mobile:justify-center mobile:items-center">
                    <div class="flex flex-col gap-2">
                        <p class="font-bold">{{ 'settings.google_auth' | transloco }}</p>
                        <p class="text-neutral-1200">{{ 'settings.google_2fa_desc' | transloco }}</p>
                    </div>
                    <div>
                        <app-toggle-button [(toggleButton)]="toggleButton"
                            [isDisabled]="editingInputDisabled"></app-toggle-button>
                    </div>
                </div>
            </div>

        </div>-->
        </div>
        <app-custom-footer></app-custom-footer>
    </div>


</div>